import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showSaviInputInHeader: false,
  ispmInputValue: '',
  isChatOverlayVisible: false,
  isSuggestionVisible: false,
  userQuery: '',
};

const ispmSlice = createSlice({
  name: 'ispmMfe',
  initialState,
  reducers: {
    setShowSaviInputInHeader: (state, action) => {
      // This approach is safe because Redux Toolkit internally uses Immer, which translates the mutation into an immutable update.
      state.showSaviInputInHeader = action.payload;
    },
    setIspmInputValue: (state, action) => {
      // Update the ispmInputValue in the state
      state.ispmInputValue = action.payload;
    },
    setUserQuery: (state, action) => {
      // Update the userQuery in the state
      state.userQuery = action.payload;
    },
    setSuggestionVisibility: (state, action) => {
      // Update the suggestion visibility
      state.isSuggestionVisible = action.payload;
    },
    setChatOverlayVisibility: (state, action) => {
      // Update the chat overlay visibility
      state.isChatOverlayVisible = action.payload;
    },
    // Reset all state to initial
    resetIspmState: () => initialState,
  },
});

export const {
  setShowSaviInputInHeader,
  resetIspmState,
  setIspmInputValue,
  setUserQuery,
  setChatOverlayVisibility,
  setSuggestionVisibility,
} = ispmSlice.actions;

export default ispmSlice.reducer;
